import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../cn";

export type CardProps = HTMLAttributes<HTMLDivElement>;

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn("border-charcoal/10 bg-sand rounded-lg border p-6 shadow-sm", className)}
      {...rest}
    />
  );
});
